import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Filter } from '../../interfaces/filter';
import { DataService } from '../../services/data.service';
import { FiltersColorHelper } from 'src/app/utils/helpers/filtersColorHelper';

@Component({
  selector: 'app-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss', './filter-item.component.en.scss'],
})
export class FilterItemComponent implements OnInit {
  @Input() filterTitle!: string;
  @Input() filterItems!: Filter[];
  @Input() valueLabel!: string;
  @Input() multi: boolean = false;
  @Input() disabled: boolean = false;
  @Input() set isLoading(value: boolean) {
    this.loadingState = value;
    if(!value) {
      if(!this.currentValueString) 
        this.initValue();

      this.detectTooltip();
    }
  }
  @Input() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() setValue: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() showFilterMobileDropdown: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeFilterMobileDropdown: EventEmitter<void> = new EventEmitter<void>();
  @HostListener('window:resize', ['$event']) onResize() {
    this.detectTooltip();
  }
  loadingState: boolean = false;
  formControl: FormControl = new FormControl('');
  showTooltip: boolean = false;
  tooltipString: string = '';
  currentValueString: string = '';
  filterMultiItems!: Filter[];
  generalSettingsData: any;
  FiltersColorHelper = FiltersColorHelper;

  constructor(private el: ElementRef, private dataService: DataService) {}

  ngOnInit() {
    this.dataService.updateGeneralSettingsData$.subscribe((value) => {
      this.generalSettingsData = value;
      this.detectTooltip();
    });

    this.initValue();
  }

  initValue() {
    if(!this.filterItems && !this.filterMultiItems) return;

    if (!this.multi) {
      this.formControl.setValue(
        this.filterItems.find((el) => el.checked)?.value || ''
      );
    } else {
      this.filterMultiItems = JSON.parse(JSON.stringify(this.filterItems));
    }
    this.setCurrentValue(this.filterItems);
  }

  setCurrentValue(vals: Filter[]) {
    this.currentValueString = vals
      .filter((el) => el.checked)
      .map((el) => el.label)
      .join(', ');
    this.tooltipString = this.currentValueString;

    this.detectTooltip();
  }

  toggleValue(value: Filter) {
    if (this.multi) {
      value.checked = !value.checked;
    } else {
      this.filterItems = this.filterItems.map((el) => {
        return { ...el, checked: value.value === el.value };
      });
      this.formControl.setValue(
        this.filterItems.find((el) => el.checked)?.value || ''
      );
    }

    this.setValue.emit(this.filterItems);
    this.setCurrentValue(this.filterItems);
  }

  saveValue(val: string) {
    const currentValue: Filter | undefined = this.filterItems.find(
      (el) => el.value === val
    );

    if (currentValue) {
      this.toggleValue(currentValue);
    }
    if (this.multi) {
      this.filterItems = JSON.parse(JSON.stringify(this.filterMultiItems));
      this.setCurrentValue(this.filterItems);
    }

    this.setValue.emit(this.filterItems);
    setTimeout(() => {
      this.close.emit();
    });
  }

  detectTooltip() {
    if(!this.generalSettingsData || this.loadingState) return;

    setTimeout(() => {
      const valueWidth =
        this.el.nativeElement.querySelector('.filter-value').offsetWidth;
      const valueFullWidth = this.el.nativeElement.querySelector(
        '.filter-value-string'
      ).offsetWidth;

      this.showTooltip = valueFullWidth > valueWidth;
    });
  }

  closeOpenFilterMobileDropdown(state: boolean) {
    if (state) {
      this.showFilterMobileDropdown.emit();
    } else {
      this.closeFilterMobileDropdown.emit();
    }
  }
}
